import React, { Component } from 'react';
import { usePricing } from '../contexts/PricingContext';
interface PriceDisplayProps {
  type?: 'current' | 'compare' | 'both';
  className?: string;
  originalClassName?: string;
  showCurrencyCode?: boolean;
}
export function PriceDisplay({
  type = 'current',
  className = 'text-3xl font-bold',
  originalClassName = 'text-lg text-gray-500 line-through decoration-red-500',
  showCurrencyCode = false
}: PriceDisplayProps) {
  const {
    currentPrice,
    comparePrice,
    formatPrice,
    isLoading
  } = usePricing();
  if (isLoading) {
    return <div className="flex flex-col items-center justify-center" data-id="element-305">
        <span className={className} data-id="element-306">
          <span className="inline-block w-24 h-8 bg-gray-200 animate-pulse rounded" data-id="element-307"></span>
        </span>
      </div>;
  }
  const formattedCurrent = formatPrice(currentPrice);
  const formattedCompare = formatPrice(comparePrice);
  if (type === 'compare') {
    return <div className="flex flex-col items-center justify-center" data-id="element-308">
        <span className={originalClassName} data-id="element-309">{formattedCompare}</span>
      </div>;
  }
  if (type === 'both') {
    return <div className="flex flex-col items-center justify-center" data-id="element-310">
        <span className={originalClassName} data-id="element-311">{formattedCompare}</span>
        <span className={className} data-id="element-312">{formattedCurrent}</span>
      </div>;
  }
  return <div className="flex flex-col items-center justify-center" data-id="element-313">
      <span className={className} data-id="element-314">{formattedCurrent}</span>
    </div>;
}
// Additional component for displaying bonus prices
interface BonusPriceDisplayProps {
  usdAmount: number;
  className?: string;
}
export function BonusPriceDisplay({
  usdAmount,
  className = ''
}: BonusPriceDisplayProps) {
  const {
    formatBonusPrice,
    isLoading
  } = usePricing();
  if (isLoading) {
    return <span className={className} data-id="element-315">...</span>;
  }
  return <span className={className} data-id="element-316">{formatBonusPrice(usdAmount)}</span>;
}
// Component for displaying the total bonus value
interface BonusTotalDisplayProps {
  className?: string;
}
export function BonusTotalDisplay({
  className = ''
}: BonusTotalDisplayProps) {
  const {
    bonusTotal,
    isLoading
  } = usePricing();
  if (isLoading) {
    return <span className={className} data-id="element-317">...</span>;
  }
  return <span className={className} data-id="element-318">{bonusTotal}</span>;
}